import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';
import type { Article } from '@/types/content';

const list = articles as Article[];

export default function TodaySection() {
  const today = list.filter((a) => a.category === 'today');
  const feature = today[0];
  const side = [...today.slice(1), ...list.filter((a) => a.category === 'hot')].slice(0, 4);

  return (
    <section id="today" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Today"
          title="今日上新"
          desc="每天早晚各一轮，把正在发酵的娱乐话题第一时间整理给你。热点不过夜，追上进度只需要五分钟。"
          linkTo="/topics?cat=today"
          linkLabel="查看今日全部"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <article className="lg:col-span-7">
            <Link
              to={`/article/${feature.id}`}
              className="group relative block w-full h-[320px] md:h-[440px] rounded-lg overflow-hidden"
            >
              <img
                src={feature.cover}
                alt={feature.title}
                title={`${feature.title} - 福利吃瓜今日上新`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent"></div>
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  今日上新
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-foreground-950/50 backdrop-blur-sm text-background-50 text-xs">
                  {feature.readTime}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <h3 className="font-heading text-xl md:text-3xl font-bold text-background-50 leading-snug line-clamp-2">
                  {feature.title}
                </h3>
                <p className="mt-3 text-xs md:text-sm text-background-200 leading-6 line-clamp-2 hidden sm:block">
                  {feature.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-3 text-xs text-background-300">
                  <span>{feature.date}</span>
                  <span className="w-1 h-1 rounded-full bg-background-400"></span>
                  <span>{feature.author}</span>
                  <span className="ml-auto inline-flex items-center gap-1 text-accent-400 font-medium">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {feature.heat}
                  </span>
                </div>
              </div>
            </Link>
          </article>

          <div className="lg:col-span-5 flex flex-col">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                <i className="ri-pulse-line text-sm" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-base font-bold text-foreground-950">今日速览</h3>
            </div>
            <div className="flex-1 rounded-lg border border-background-200 bg-background-50 px-5 py-2">
              {side.map((a) => (
                <ArticleCard key={a.id} article={a} variant="minimal" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}